package org.gstechnovos.jexonplastech.components.layouts

import androidx.compose.runtime.Composable
import com.iregained.site.components.sections.header.NavHeader
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import org.gstechnovos.jexonplastech.sections.footer.MainFooter

@Composable
fun PageLayout(content: @Composable () -> Unit) {
    Column(
        modifier = Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        NavHeader() // This puts your menu at the top of every page

        Box(modifier = Modifier.fillMaxSize().weight(1f)) {
            content() // This is where your page-specific code goes
        }

        // You can add a Footer() here later!
        MainFooter()
    }
}